// extracted by mini-css-extract-plugin
export default {"roleCell":"vcO1Fpjw6aMsgndrTCdI","roleName":"cDFtzq9w57U4WU2Jtdw3","roleDesc":"iKS9QnHELaYkJilPSgTX","arrowBtn":"dZB0v1Gdm5hxUWNDbG3D","search":"xYFMp80Az4trXHeDgpSL"};